import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UpdateQuoteClientData } from "../types";
import { updateQuoteClient } from "../apis/updateQuoteClient";

export const useUpdateQuoteClient = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, UpdateQuoteClientData>({
        mutationFn: updateQuoteClient,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
            queryClient.invalidateQueries({ queryKey: ["clients"] });
        },
    });
};
